import React from 'react'

const context: { currentUser: Api.User | null } = {
  currentUser: null,
}

export const MainContext = React.createContext(context)
